const stats = [
  { label: 'Players on Roster', value: '53' },
  { label: 'Pro Bowl Selections', value: '6' },
  { label: 'Division Titles', value: '19+' },
  { label: 'Years of Vikings Football', value: '65' },
];

export default function TeamHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      {/* Background */}
      <img
        src="https://public.readdy.ai/ai/img_res/ed39c0db4726a8d06e4d2e981856da64.jpg"
        alt="Minnesota Vikings Team"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-[#2a0a3d]/90"></div>

      {/* Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 pt-16">
        <p className="text-[#ffd700] text-xs font-bold tracking-widest uppercase mb-3" style={{ fontFamily: "'Oswald', sans-serif" }}>
          Minnesota Vikings
        </p>
        <h1 className="text-4xl md:text-6xl font-black text-white uppercase leading-none mb-4" style={{ fontFamily: "'Oswald', sans-serif" }}>
          Meet The Team
        </h1>
        <p className="text-white/70 text-sm md:text-base max-w-xl mb-10">
          Explore the full 2025–26 roster, coaching staff, and the players who wear the purple and gold with pride every Sunday.
        </p>

        {/* Stats Bar */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl md:text-3xl font-black text-[#ffd700]" style={{ fontFamily: "'Oswald', sans-serif" }}>
                {stat.value}
              </p>
              <p className="text-white/60 text-xs tracking-wider uppercase" style={{ fontFamily: "'Oswald', sans-serif" }}>
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
